import fetch from '@/helpers/fetch'

export default {
	state: {
		user: null,
		loggedin: null,
		usersList: null,
	},
	mutations: {
		SET_LOGGEDIN(state, loggedin: boolean) {
			state.loggedin = loggedin
		},
		SET_USER(state, user: boolean) {
			state.user = user
		},
		SET_USERS_LIST(state, usersList) {
			const mainUsers = [
				'aniele.fortunato@locatelliadv.com.br',
				'camila.andrade@locatelliadv.com.br',
				'daniel.mello@locatelliadv.com.br',
				'eduardo.souto@locatelliadv.com.br',
				'emilly.chaves@locatelliadv.com.br',
				'gislene.lima@locatelliadv.com.br',
				'giulia.martins@locatelliadv.com.br',
				'lucas.vidal@locatelliadv.com.br',
				'maicon.galafassi@locatelliadv.com.br',
				'mariana.souto@locatelliadv.com.br',
				'caio.lopes@locatelliadv.com.br',
			]

			usersList = usersList.filter((user) => {
				return user.email.includes('locatelliadv.com.br')
			})

			usersList.sort((user1, user2) => {
				if (
					mainUsers.indexOf(user1.email) > -1 &&
					mainUsers.indexOf(user2.email) === -1
				) {
					return -1
				}

				if (
					mainUsers.indexOf(user2.email) > -1 &&
					mainUsers.indexOf(user1.email) === -1
				) {
					return 1
				}

				if (user1.email > user2.email) {
					return 1
				}

				if (user1.email > user2.email) {
					return -1
				}

				return 0
			})

			state.usersList = usersList
		},
	},
	actions: {
		login: async function (context, query: string): Promise<object> {
			const data = await fetch.get('/api/login' + query)
			return data
		},
		logout: async function (): Promise<object> {
			const data = await fetch.post('/api/logout', {})
			return data
		},
		fetchUsersList: async function (context): Promise<object | void> {
			if (!context.usersList) {
				const resp = await fetch.get('/api/users2')
				context.commit('SET_USERS_LIST', resp.data)
			}
		},
	},
}
